import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { Period } from "../../generated/core-api";

export function useActiveUsers(
  fromDate: string,
  toDate: string,
  period: Period,
) {
  return useQuery({
    queryKey: ["platformAnalytics", "activeUsers", fromDate, toDate, period],
    queryFn: () =>
      api.getActiveUsers({ from_date: fromDate, to_date: toDate, period }),
  });
}
